/**
 * Plays a short two-tone "ping" via the Web Audio API. No asset file — the
 * sound is synthesized so we don't ship a binary just for this. Safe to call
 * before user interaction: browsers may suspend the AudioContext until a
 * gesture, in which case this becomes a no-op and resumes on the next call
 * after the user clicks anywhere.
 */
let ctx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (ctx && ctx.state !== 'closed') return ctx;
  const Ctor = window.AudioContext
    || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
}

export function playNotificationSound(): void {
  const audio = getContext();
  if (!audio) return;
  // If the page hasn't had a user gesture yet, AudioContext may be suspended.
  // resume() is a best-effort; the play call below becomes silent if denied.
  if (audio.state === 'suspended') {
    audio.resume().catch(() => undefined);
  }

  const now = audio.currentTime;
  const gain = audio.createGain();
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
  gain.connect(audio.destination);

  const tone1 = audio.createOscillator();
  tone1.type = 'sine';
  tone1.frequency.setValueAtTime(880, now);
  tone1.frequency.exponentialRampToValueAtTime(1320, now + 0.12);
  tone1.connect(gain);
  tone1.start(now);
  tone1.stop(now + 0.35);
}
